import $ from 'jQuery';

export default function () {
    $(function() {
        // Select all expand icons from this block
        var icons = document.querySelectorAll('.block--four-column-list__heading .icon');

        // Iterate over each element
        icons.forEach(function(icon) {
            // Add an event listener for the 'click' event
            icon.addEventListener('click', function() {
                // Toggle the 'expanded' class on the parent element of the clicked element
                this.parentElement.classList.toggle('expanded');

                // Find the closest div that matches the selector '.block--four-column-list'. This is needed in case there are many blocks of this type, we just want to expand/collapse this one
                var ancestor = $(this).closest('.block--four-column-list');

                // If the div exists, find the div with the class 'block--four-column-list__columns'
                if (ancestor.length) {
                    var columnsDiv = ancestor.find('.block--four-column-list__columns');

                    // If the div exists, toggle its display property between 'block' and 'none'
                    if (columnsDiv.length) {
                        columnsDiv.slideToggle();
                        if (columnsDiv.css('display') != 'none') {
                            columnsDiv.css('display', 'flex');
                        }
                    }
                }
            });
        });
    });
}
